"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveTikTokBidPrice = exports.normalizeTikTokOptimizationGoal = exports.findGoalOption = exports.getAllowedObjectivesForProduct = exports.getDefaultGoalForObjective = exports.getObjectiveRules = exports.TIKTOK_ADS_PRODUCT_OBJECTIVES = exports.TIKTOK_ADS_OBJECTIVE_RULES = void 0;
const tiktok_ads_1 = require("./tiktok-ads");
const GOAL = tiktok_ads_1.TikTokAdsOptimizationGoal;
const BILL = tiktok_ads_1.TikTokAdsBillingEvent;
exports.TIKTOK_ADS_OBJECTIVE_RULES = {
    [tiktok_ads_1.TikTokAdsObjective.REACH]: {
        objective: tiktok_ads_1.TikTokAdsObjective.REACH,
        goals: [
            {
                goal: GOAL.REACH,
                billing: BILL.CPM,
                label: "Reach (CPM)",
                requiresBid: true,
                defaultBid: 10,
            },
        ],
        defaultGoalIndex: 0,
        promotionType: undefined,
        requiresFrequency: true,
        requiresLandingPage: false,
        blockedUntilIntegration: false,
    },
    [tiktok_ads_1.TikTokAdsObjective.TRAFFIC]: {
        objective: tiktok_ads_1.TikTokAdsObjective.TRAFFIC,
        goals: [
            {
                goal: GOAL.CLICK,
                billing: BILL.CPC,
                label: "Clicks (CPC)",
                requiresBid: true,
                defaultBid: 0.5,
            },
        ],
        defaultGoalIndex: 0,
        promotionType: "WEBSITE",
        requiresFrequency: false,
        requiresLandingPage: true,
        blockedUntilIntegration: false,
    },
    [tiktok_ads_1.TikTokAdsObjective.VIDEO_VIEWS]: {
        objective: tiktok_ads_1.TikTokAdsObjective.VIDEO_VIEWS,
        goals: [
            {
                // Sandbox rejects VIDEO_VIEW; ENGAGED_VIEW is the supported path.
                goal: GOAL.ENGAGED_VIEW,
                billing: BILL.CPV,
                label: "Engaged view (CPV)",
                requiresBid: true,
                defaultBid: 0.05,
            },
        ],
        defaultGoalIndex: 0,
        promotionType: undefined,
        requiresFrequency: false,
        requiresLandingPage: false,
        blockedUntilIntegration: false,
    },
    [tiktok_ads_1.TikTokAdsObjective.ENGAGEMENT]: {
        objective: tiktok_ads_1.TikTokAdsObjective.ENGAGEMENT,
        goals: [
            {
                // Kept for draft defaults; publish is blocked — Community Interaction
                // requires Spark Ads (organic post), which we don't support yet.
                goal: GOAL.POST_ENGAGEMENT,
                billing: BILL.OCPM,
                label: "Post engagement (oCPM)",
                requiresBid: true,
                defaultBid: 5,
            },
        ],
        defaultGoalIndex: 0,
        promotionType: undefined,
        requiresFrequency: false,
        requiresLandingPage: false,
        blockedUntilIntegration: true,
        blockReason: "Engagement (Community Interaction) only runs as Spark Ads from an organic TikTok post. Use Traffic, Reach, or Video Views for uploaded video ads.",
    },
    [tiktok_ads_1.TikTokAdsObjective.LEAD_GENERATION]: {
        objective: tiktok_ads_1.TikTokAdsObjective.LEAD_GENERATION,
        goals: [
            {
                goal: GOAL.LEAD_GENERATION,
                billing: BILL.OCPM,
                label: "Leads (oCPM)",
                /** Sandbox rejects adgroup/create without cost-per-conversion (40002). */
                requiresBid: true,
                defaultBid: 10,
            },
        ],
        defaultGoalIndex: 0,
        promotionType: "LEAD_GENERATION",
        requiresFrequency: false,
        requiresLandingPage: false,
        /** Instant Form page_id unlocks publish; Instant Page Editor SDK is out of scope. */
        blockedUntilIntegration: false,
    },
    [tiktok_ads_1.TikTokAdsObjective.WEB_CONVERSIONS]: {
        objective: tiktok_ads_1.TikTokAdsObjective.WEB_CONVERSIONS,
        goals: [
            {
                goal: GOAL.CONVERT,
                billing: BILL.OCPM,
                label: "Conversions (oCPM)",
                requiresBid: true,
                defaultBid: 10,
            },
        ],
        defaultGoalIndex: 0,
        promotionType: "WEBSITE",
        requiresFrequency: false,
        requiresLandingPage: true,
        blockedUntilIntegration: false,
    },
};
/** Product type → which campaign objectives are allowed. */
exports.TIKTOK_ADS_PRODUCT_OBJECTIVES = {
    [tiktok_ads_1.TikTokAdsProductType.IN_FEED]: [
        tiktok_ads_1.TikTokAdsObjective.REACH,
        tiktok_ads_1.TikTokAdsObjective.TRAFFIC,
        tiktok_ads_1.TikTokAdsObjective.VIDEO_VIEWS,
        tiktok_ads_1.TikTokAdsObjective.LEAD_GENERATION,
        tiktok_ads_1.TikTokAdsObjective.WEB_CONVERSIONS,
    ],
    /** Reservation TopView — campaign uses RF_REACH, not auction REACH. */
    [tiktok_ads_1.TikTokAdsProductType.TOPVIEW]: [tiktok_ads_1.TikTokAdsObjective.REACH],
};
const getObjectiveRules = (objective) => exports.TIKTOK_ADS_OBJECTIVE_RULES[objective];
exports.getObjectiveRules = getObjectiveRules;
const getDefaultGoalForObjective = (objective) => {
    var _a;
    const rules = (0, exports.getObjectiveRules)(objective);
    return (_a = rules.goals[rules.defaultGoalIndex]) !== null && _a !== void 0 ? _a : rules.goals[0];
};
exports.getDefaultGoalForObjective = getDefaultGoalForObjective;
const getAllowedObjectivesForProduct = (productType) => {
    var _a;
    return (_a = exports.TIKTOK_ADS_PRODUCT_OBJECTIVES[productType]) !== null && _a !== void 0 ? _a : exports.TIKTOK_ADS_PRODUCT_OBJECTIVES[tiktok_ads_1.TikTokAdsProductType.IN_FEED];
};
exports.getAllowedObjectivesForProduct = getAllowedObjectivesForProduct;
const findGoalOption = (objective, goal) => (0, exports.getObjectiveRules)(objective).goals.find((option) => option.goal === goal);
exports.findGoalOption = findGoalOption;
/**
 * Remap legacy / unsupported goal values before hitting TikTok.
 * VIDEO_VIEW → ENGAGED_VIEW (sandbox + many accounts reject VIDEO_VIEW).
 * ENGAGED_VIEW / ENGAGEMENT under ENGAGEMENT objective → POST_ENGAGEMNT
 * (CPV is VIDEO_VIEWS-only; ENGAGEMENT is not a valid optimization_goal).
 */
const normalizeTikTokOptimizationGoal = (goal, objective) => {
    if (objective === tiktok_ads_1.TikTokAdsObjective.ENGAGEMENT) {
        if (goal === "ENGAGED_VIEW" ||
            goal === "VIDEO_VIEW" ||
            goal === "ENGAGEMENT" ||
            goal === "CPV") {
            return tiktok_ads_1.TikTokAdsOptimizationGoal.POST_ENGAGEMENT;
        }
    }
    if (goal === "VIDEO_VIEW") {
        return tiktok_ads_1.TikTokAdsOptimizationGoal.ENGAGED_VIEW;
    }
    if (goal === "ENGAGEMENT") {
        return tiktok_ads_1.TikTokAdsOptimizationGoal.POST_ENGAGEMENT;
    }
    return goal;
};
exports.normalizeTikTokOptimizationGoal = normalizeTikTokOptimizationGoal;
/** Resolve bid to send: user value, or matrix default when the goal requires one. */
const resolveTikTokBidPrice = (objective, goal, bidPrice) => {
    var _a;
    const option = (_a = (0, exports.findGoalOption)(objective, goal)) !== null && _a !== void 0 ? _a : (0, exports.getDefaultGoalForObjective)(objective);
    if (bidPrice !== null && bidPrice !== undefined && bidPrice > 0) {
        return bidPrice;
    }
    if (option.requiresBid) {
        return option.defaultBid;
    }
    return undefined;
};
exports.resolveTikTokBidPrice = resolveTikTokBidPrice;
